/* ラベル表示 */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';

interface Props {
  text: string;
  label: string;
  need?: boolean;
  show?: boolean;
}

const Label: React.FC<Props> = ({ label, need, show, text }) => {
  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return (
      <Row>
        <Col dangerouslySetInnerHTML={{ __html: text }}></Col>
      </Row>
    );
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      looks_inactive={true}
      show={show}
      content={returnLabelJsx()}
    />
  );
};

export default Label;
